'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import FavoritesModalImage from '@/app/_components/FavoritesModalImage';
import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton';
import { withMinDuration } from '@/app/_lib/services/ClientUtil';
import updateFavoritesListAction from '@/app/_lib/actions/UpdateFavoritesListAction';
import { useGlobalMessage } from '@/app/_lib/hooks';
const EditFavoritesListModal = t0 => {
  const $ = _c(51);
  const {
    isOpen,
    setIsOpen,
    contentLabel,
    favoritesList,
    favoritesListIndex,
    onListRenamed
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  const addGlobalMessage = useGlobalMessage();
  const [listName, setListName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  let t2;
  let t3;
  if ($[1] !== favoritesList) {
    t2 = () => {
      if (favoritesList) {
        setListName(favoritesList.list_name || "");
      }
    };
    t3 = [favoritesList];
    $[1] = favoritesList;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== favoritesList) {
    t4 = () => {
      setErrorMessage("");
      if (favoritesList) {
        setListName(favoritesList.list_name || "");
      }
    };
    $[4] = favoritesList;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const afterOpenModal = t4;
  let t5;
  if ($[6] !== setIsOpen) {
    t5 = () => {
      setIsOpen(false);
    };
    $[6] = setIsOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const closeModal = t5;
  let t6;
  if ($[8] !== addGlobalMessage || $[9] !== closeModal || $[10] !== favoritesListIndex || $[11] !== onListRenamed) {
    t6 = async formData => {
      const newListName = formData.get("list_name");
      if (!newListName || !newListName.trim()) {
        setErrorMessage("Please enter a list name.");
        return;
      }
      setErrorMessage("");
      const data = {
        list_index: favoritesListIndex,
        list_name: newListName.trim()
      };
      const response = await withMinDuration(updateFavoritesListAction(data), 700);
      if (response.success) {
        addGlobalMessage({
          message: "List renamed successfully.",
          messageType: "success"
        });
        if (onListRenamed) {
          onListRenamed(newListName.trim());
        }
        closeModal();
      } else {
        setErrorMessage(response.message || Object.values(response.errors || {})[0] || "An error occurred. Please try again.");
      }
    };
    $[8] = addGlobalMessage;
    $[9] = closeModal;
    $[10] = favoritesListIndex;
    $[11] = onListRenamed;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleSubmit = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faXmark} className="text-lg" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== closeModal) {
    t8 = <button type="button" onClick={closeModal} className="hidden md:flex absolute -top-4 -right-4 w-8 h-8 items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10" aria-label="Close">{t7}</button>;
    $[14] = closeModal;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FavoritesModalImage alt="Rename favorites list" />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FontAwesomeIcon icon={faXmark} className="text-[28px]" />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== closeModal) {
    t11 = <button onClick={closeModal} className="md:hidden absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close">{t10}</button>;
    $[18] = closeModal;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-3 mb-3"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-2xl text-[#F5A623]" /><h2 className="text-2xl md:text-3xl font-extralight">Rename List</h2></div>;
    t13 = <p className="text-sm text-gray-600 mb-2">Enter a new name for your favorites list.</p>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t12 = $[20];
    t13 = $[21];
  }
  let t14;
  if ($[22] !== errorMessage) {
    t14 = errorMessage && <p className="text-sm text-red-600 mb-4">{errorMessage}</p>;
    $[22] = errorMessage;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e => setListName(e.target.value);
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== listName) {
    t16 = <input id="edit_list_name" type="text" name="list_name" value={listName} onChange={t15} autoComplete="off" placeholder=" " required={true} className="form-input peer" />;
    $[25] = listName;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <label htmlFor="edit_list_name" className="form-input-label peer-placeholder-shown:form-input-label-placeholder-shown">List Name</label>;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16) {
    t18 = <div className="form-group mb-4">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SubmitWithPendingButton pendingText="Saving..." size="sm">Save Changes</SubmitWithPendingButton>;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== closeModal) {
    t20 = <div className="flex items-center gap-4">{t19}<button type="button" onClick={closeModal} className="text-xs text-gray-400 hover:text-gray-600 transition-colors underline">Cancel</button></div>;
    $[31] = closeModal;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== handleSubmit || $[34] !== t14 || $[35] !== t18 || $[36] !== t20) {
    t21 = <form action={handleSubmit}>{t14}{t18}{t20}</form>;
    $[33] = handleSubmit;
    $[34] = t14;
    $[35] = t18;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t11 || $[39] !== t21) {
    t22 = <div>{t11}{t12}{t13}{t21}</div>;
    $[38] = t11;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="mt-10"><p className="text-xs text-light leading-relaxed italic">Your favorites lists are saved to your account and can be accessed from any device when signed in.</p></div>;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t22) {
    t24 = <div className="flex flex-col md:flex-row">{t9}<div className="w-full md:w-1/2 px-6 md:px-8 py-10 md:py-14 pb-2 md:pb-3 relative flex flex-col justify-between order-1 md:order-2">{t22}{t23}</div></div>;
    $[42] = t22;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== afterOpenModal || $[45] !== closeModal || $[46] !== contentLabel || $[47] !== isOpen || $[48] !== t24 || $[49] !== t8) {
    t25 = <Modal overlayClassName="z-[1055] fixed outline-0 top-0 bottom-0 left-0 right-0 bg-modal-overlay" className="fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[400px] md:max-w-[800px] rounded-sm bg-white shadow-2xl outline-none overflow-visible" isOpen={isOpen} onAfterOpen={afterOpenModal} onRequestClose={closeModal} contentLabel={contentLabel} closeTimeoutMS={300} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t8}{t24}</Modal>;
    $[44] = afterOpenModal;
    $[45] = closeModal;
    $[46] = contentLabel;
    $[47] = isOpen;
    $[48] = t24;
    $[49] = t8;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  return t25;
};
export default EditFavoritesListModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}